import { search_asp } from "../util";


export function translateCompress2dDotPlot(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(compress_2d_dotplot,L).  
  let layer = source?.layer?.[mapping[args[0]].layer];
  let dir, p;
  if ((p = search_asp(parsed, `detect(point_mark_compressable,${args[0]},`, "startsWith"), p.length == 1)) {
    dir = p[0].args[2];
  }
  if (dir) {
    let field = source.layout?.[dir]?.[0]?.field;

    // conditioning check
    let values = source.datatype[field]?.values;
    let min_neg = - Infinity, min_pos = Infinity;
    for (let d of values) {
      if (d < 0 && min_neg < d) {
        min_neg = d;
      } else if (d >= 0 && min_pos > d) {
        min_pos = d;
      }
    }
    let side;
    if (min_neg !== undefined && min_pos !== undefined) {
      side = "both"
    } else if (min_neg !== undefined) {
      side = "neg"
    } else if (min_pos !== undefined) {
      side = "pos"
    }
    if (side) {
      // sizing rule
      let org_padding = source.layout.padding
      let height = (side === "both" ? 50 : 25) + (org_padding?.top ? 20 : 0) + (org_padding?.bottom ? 20 : 0);
      let padding = {
        top: org_padding?.top ? 20 : 0,
        bottom: org_padding?.bottom ? 20 : 0
      }
      let rule_resizing = {
        category: "recommender",
        description: `Adjust height and remove padding`,
        specifier: { "role": "view" },
        action: "modify",
        option: {
          height,
          padding,
        }
      }
      rules.push(rule_resizing);
      // axis offset adjust
      let axis = dir === "row" ? "haxis" : "vaxis"
      if (source.layout[axis]?.offset) {
        let rule_axis_offset = {
          category: "recommender",
          description: `Modify the ${axis} offset`,
          specifier: { "role": dir === "row" ? "hAxis" : "vAxis" },
          action: "modify",
          option: {
            offset: (side === "both" ? -25 : 0)
          }
        }
        rules.push(rule_axis_offset);
      }
      // add calculate
      let expression, output = field + "p";
      if (side === "both") {
        expression = `(datum.${field} < 0 ? ${min_neg} : ${min_pos} )`
      } if (side === "neg") {
        expression = `(datum.${field} ? ${min_neg} : datum.${field} )`
      } if (side === "pos") {
        expression = `(datum.${field} ? ${min_pos} : datum.${field} )`
      }

      let rule_calculate = {
        category: "recommender",
        description: `Add a caclualte`,
        specifier: { "role": "transform" },
        action: "add",
        option: {
          operation: "calculate",
          expression,
          output
        }
      };
      rules.push(rule_calculate);

      // replace the rc
      let rule_field = {
        category: "recommender",
        description: `Remove a ${dir} field`,
        specifier: { "role": "view." + dir, field, index: 0 },
        action: "remove",
      };
      let rule_field2 = {
        category: "recommender",
        description: `Add a ${dir} field`,
        specifier: { "role": "view." + dir },
        action: "add",
        option: {
          field: output,
          index: 0
        }
      };
      rules.push(rule_field, rule_field2);

      // change mark opacity
      let rule_mark = {
        category: "recommender",
        description: `Modify mark opacity`,
        specifier: { "role": "mark" },
        action: "modify",
        option: {
          opacity: { value: 0.3 }
        }
      };
      if (layer.name) rule_mark.specifier.id = layer.name;
      else rule_mark.specifier.index = parseInt(mapping[args[0]].layer);
      rules.push(rule_mark);

      let be_ext_num = (search_asp(parsed, "do(externalize_data_annotations,with_numbering,adjust)").length == 1);
      if (be_ext_num) {
        source.annotation?.items?.forEach((anno, ni) => {
          if (!anno.anchor?.dataItem) return;
          let rel_val = anno.anchor.dataItem.datum[field];
          let facing_side;
          if (side === "both" && rel_val < 0) facing_side = "bottom";
          else facing_side = "top";
          let rule_reposition = {
            category: "recommender",
            description: `Reposition annotation [${anno.name || ""}] and remove ticks`,
            specifier: {
              "role": "annotation"
            },
            action: "modify",
            option: {
              tick: null,
              width: 8,
            }
          };
          if (dir === "row") {
            rule_reposition.option.dx = 4;
            rule_reposition.option.dy = facing_side === "top" ? -13 : 20;
          } else {
            rule_reposition.option.dy = -6;
            rule_reposition.option.dx = facing_side === "top" ? 10 : -18;
          }
          if (anno.name) rule_reposition.specifier.id = anno.name;
          else rule_reposition.specifier.index = ni;
          rules.push(rule_reposition);
        })
      }
    }
  }
  return rules;
}

export function translateBarTo1dDotPlot(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(bar_to_oneD_dotplot,r0,c0,transpose). 
  let row = source?.layout?.row?.[mapping[args[0]]['layout.row']];
  let column = source?.layout?.column?.[mapping[args[1]]['layout.column']];
  let isTranspose = args[2] === "transpose"
  console.log(row, column, isTranspose);
  if (row && column) {
    if (isTranspose) {
      rules.push({
        category: "recommender",
        description: `Transpose axes`,
        specifier: { "role": "view" },
        action: "transpose"
      });
    }
    // sizing
    rules.push({
      category: "recommender",
      description: `Set chart height`,
      specifier: { "role": "view" },
      action: "modify",
      option: { height: 200 }
    });
    // remove axis
    rules.push({
      category: "recommender",
      description: `Remove the row`,
      specifier: { "role": "view.row", index: 0 },
      action: "remove"
    });
    // modify axis scale domain
    let range = source.datatype[column.field].max - source.datatype[column.field].min;
    let newDomain = [Math.round(source.datatype[column.field].min - range * 0.1), Math.round(source.datatype[column.field].max + range * 0.1)]
    rules.push({
      category: "recommender",
      description: `Modify column scale`,
      specifier: { "role": "view.column", index: 0 },
      action: "modify",
      option: {
        scale: {
          domain: newDomain
        }
      }
    });

    // add axis domain
    rules.push({
      category: "recommender",
      description: `Add axis domain`,
      specifier: { "role": "hAxis", field: column.field },
      action: "modify",
      option: {
        domain: true,
        offset: -100,
        stroke: "rgba(122,122,122,1)",
        strokeWidth: 1,
      }
    });

    let rule_mark = {
      category: "recommender",
      description: "Convert mark type to dot",
      specifier: { "role": "mark" },
      action: "modify",
      option: {
        type: "circle",
        size: { value: 70 }
      }
    }
    if (source.layer[0].name) rule_mark.specifier.id = source.layer[0].name;
    else rule_mark.specifier.index = 0;
    rules.push(rule_mark);

    let n_mark_texts = source.layer[0].text.filter((d) => d.type === "on-mark").length;
    source.layer[0].text?.forEach((text, ti) => {
      if (text.type === "on-axis" && text.field === (isTranspose ? column : row).field) {
        let rule_text = {
          category: "recommender",
          description: "Convert axis label to mark label",
          specifier: { "role": "axis.label", field: text.field, layer: {} },
          action: "replace",
          option: {
            to: { role: "mark.label", orient: "bottom-center", anchor: "middle", textAlign: "center", dx: 0, dy: 5, id: "label_" + n_mark_texts }
          }
        }
        n_mark_texts += 1;
        if (text.serial) rule_text.option.to.serial = false;
        if (text.name) rule_text.specifier.id = text.name;
        else rule_text.specifier.index = ti;
        if (source.layer[0].name) rule_text.specifier.layer.id = source.layer[0].name;
        else rule_text.specifier.layer.index = 0;
        rules.push(rule_text);
      } else if (text.type === "on-mark") {
        let rule_text = {
          category: "recommender",
          description: "Reposition mark label",
          specifier: { "role": "mark.label", field: text.field, layer: {} },
          action: "modify",
          option: {
            orient: "top-center", anchor: "middle", dx: 0, dy: -20,
            items: { index: 0, textAlign: "center", fontWeight: '400', color: 'rgba(0,0,0,1)' }
          }
        }
        if (text.name) rule_text.specifier.id = text.name;
        else rule_text.specifier.index = ti;
        if (source.layer[0].name) rule_text.specifier.layer.id = source.layer[0].name;
        else rule_text.specifier.layer.index = 0;
        rules.push(rule_text);
      }
    })
  }
  return rules;
}